import { v4 as uuidv4 } from "uuid";
import {
  IThuPhiTab,
  IThuPhiThongTinBienLai,
} from "../../../model/request/thu-phi/IThuPhiTab";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IThuPhiActionTypes } from "../../action-types/thu-phi/IThuPhiActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiReducer } from "../../reducer-model/thu-phi/IThuPhiReducer";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";

const iniTab: IThuPhiTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuKhacs: [],
  mucThuKhacSelectedIds: [],
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  hocKy: 0,
  namHoc: "",
  qrCode: {
    bank_code_vnpay: "",
    id_encode: 0,
    qrcode: "",
    show_modal: false,
  } as IQRCodeResponse,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    ngayThu: undefined,
  } as IThuPhiThongTinBienLai,
};
const iniState: IThuPhiReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiReducer = (
  state: IThuPhiReducer = iniState,
  action: IThuPhiActionTypes
): IThuPhiReducer => {
  switch (action.type) {
    case "THU_PHI_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
              step: t.thongTinBienLai.bienLaiId > 0 ? t.step : 0,
              hocKy: action.payload.hoc_ky,
              namHoc: action.payload.nam_hoc,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: action.payload.data,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [],
              // step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuKhacSelectedIds.includes(item)
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: action.payload.data,
              mucThuKhacs: t.mucThuKhacs.map((g) => {
                if (action.payload.data.includes(g.id_thu_chi)) {
                  if (muc_thu_selected_id_news?.includes(g.id_thu_chi)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(
                        g.lop_tin_chis && g.lop_tin_chis.length > 0
                          ? g.lop_tin_chis.reduce(
                              (a, b) => a + (b.so_tien_con_lai ?? 0),
                              0
                            )
                          : g.so_tien_con_lai
                      ),
                      lop_tin_chis: g?.lop_tin_chis?.map((ltc) => {
                        return {
                          ...ltc,
                          is_choose: true,
                          so_tien_thuc_nop: Math.abs(ltc.so_tien_con_lai ?? 0),
                        };
                      }),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                  lop_tin_chis: g?.lop_tin_chis?.map((ltc) => {
                    return {
                      ...ltc,
                      is_choose: false,
                      so_tien_thuc_nop: 0,
                    };
                  }),
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs_LOP_TIN_CHI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.lop_tin_chis && mtk.lop_tin_chis.length > 0) {
                    const lop_tin_chis_choose = mtk.lop_tin_chis.filter((g) =>
                      action.payload.data.includes(g.id_lop_tc)
                    );
                    const { so_tien, so_tien_mien_giam, so_tien_da_nop } =
                      lop_tin_chis_choose.reduce(
                        (acc, item) => {
                          acc.so_tien += item.hoc_phi_theo_hoc_phan;
                          acc.so_tien_mien_giam += item.so_tien_mg_neu_co || 0;
                          if (item.is_da_nop_du)
                            acc.so_tien_da_nop += item.hoc_phi_theo_hoc_phan;
                          return acc;
                        },
                        { so_tien: 0, so_tien_mien_giam: 0, so_tien_da_nop: 0 }
                      );
                    return {
                      ...mtk,
                      so_tien_thuc_nop: Math.abs(
                        so_tien - so_tien_mien_giam - so_tien_da_nop
                      ),
                      lop_tin_chis: mtk.lop_tin_chis.map((ltc) => {
                        return {
                          ...ltc,
                          is_choose: action.payload.data.includes(
                            ltc.id_lop_tc
                          ),
                          so_tien_thuc_nop: action.payload.data.includes(
                            ltc.id_lop_tc
                          )
                            ? Math.abs(
                                ltc.hoc_phi_theo_hoc_phan -
                                  (ltc?.so_tien_mg_neu_co ?? 0) -
                                  (ltc?.so_tien_da_nop ?? 0)
                              )
                            : 0,
                        };
                      }),
                    };
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [
                ...t.mucThuKhacSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_thu_chi ?? 0)
                ),
                action.payload.data > 0
                  ? action.payload.request?.id_thu_chi ?? 0
                  : 0,
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id_thu_chi === action.payload.request.id_thu_chi) {
                    if (action.payload.request.id_lop_tc) {
                      return {
                        ...mtk,
                        lop_tin_chis: mtk.lop_tin_chis?.map((ltc) => {
                          if (
                            ltc.id_lop_tc === action.payload.request.id_lop_tc
                          ) {
                            return {
                              ...ltc,
                              so_tien_thuc_nop: action.payload.data,
                              is_choose: action.payload.data > 0,
                            };
                          }
                          return ltc;
                        }),
                        so_tien_thuc_nop: mtk.lop_tin_chis
                          ?.filter(
                            (g) =>
                              g.id_lop_tc !== action.payload.request.id_lop_tc
                          )
                          ?.reduce(
                            (a, b) => a + (b.so_tien_thuc_nop ?? 0),
                            action.payload.data
                          ),
                      };
                    } else {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };

    case "THU_PHI_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuKhacs: [],
                mucThuKhacSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START_BY_MUCTHUID":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            action.payload.filter((value) =>
              t.mucThuKhacs.map((p) => p.id).includes(value)
            ).length > 0 &&
            t.thongTinBienLai.bienLaiId <= 0
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              hinhThucNops: [],
              mucThuKhacs: [],
              mucThuKhacSelectedIds: [],
              step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_QRCODE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCode: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
